// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"353":"23ca42fd","453":"0ab8bf7d","726":"816655bb"}[chunkId] + ".chunk.js";
};